import { render, staticRenderFns } from "./StaffAddEvaluator.vue?vue&type=template&id=212fe896&scoped=true&"
import script from "./StaffAddEvaluator.vue?vue&type=script&lang=js&"
export * from "./StaffAddEvaluator.vue?vue&type=script&lang=js&"
import style0 from "./StaffAddEvaluator.vue?vue&type=style&index=0&id=212fe896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212fe896",
  null
  
)

export default component.exports